import { type HTMLAttributes } from 'react';

export interface SurfaceCardProps extends HTMLAttributes<HTMLDivElement> {
  /**
   * Inner padding. `default` is responsive (`p-2` on mobile, `p-6` from `sm`
   * up); the larger sizes are meant for centered empty/error states.
   */
  padding?: 'default' | 'sm' | 'lg' | 'xl' | 'none';
}

const paddingStyles: Record<
  NonNullable<SurfaceCardProps['padding']>,
  string
> = {
  none: '',
  sm: 'p-4',
  default: 'p-2 sm:p-6',
  lg: 'p-8',
  xl: 'p-12',
};

/**
 * The app's standard surface panel: themed background, border and rounded
 * corners. Compose extra layout (`space-y-*`, `flex`, `shadow-sm`, ...) via
 * `className`.
 */
export function SurfaceCard({
  padding = 'default',
  className = '',
  children,
  ...props
}: SurfaceCardProps) {
  return (
    <div
      className={`border-(--color-border) bg-(--color-bg-primary) rounded-xl border ${paddingStyles[padding]} ${className}`.trim()}
      {...props}
    >
      {children}
    </div>
  );
}
